(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbs-about"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sbs-about-parallax')) {
  customElements.define('sbs-about-parallax', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enabled !== 'true') return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motionQuery = matchMedia('(min-width:901px) and (prefers-reduced-motion:no-preference)');
      const update = () => {
        this.frame = null;
        if (!this.motionQuery.matches) return;
        const rect = this.getBoundingClientRect();
        const viewport = window.innerHeight;
        if (rect.bottom < 0 || rect.top > viewport) return;
        const progress = Math.max(-1, Math.min(1, (viewport / 2 - rect.top - rect.height / 2) / ((viewport + rect.height) / 2)));
        this.style.setProperty('--sbs-about-shift', `${(progress * 14).toFixed(2)}px`);
      };
      const schedule = () => {
        if (this.frame == null && this.motionQuery.matches) this.frame = requestAnimationFrame(update);
      };
      const sync = () => {
        this.toggleAttribute('data-parallax', this.motionQuery.matches);
        if (!this.motionQuery.matches) this.style.removeProperty('--sbs-about-shift');
        schedule();
      };
      window.addEventListener('scroll', schedule, {passive:true, signal});
      window.addEventListener('resize', sync, {passive:true, signal});
      this.motionQuery.addEventListener('change', sync, {signal});
      sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.frame != null) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.removeAttribute('data-parallax');
      this.style.removeProperty('--sbs-about-shift');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbs-home-adventure"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sbs-song-stage')) {
  customElements.define('sbs-song-stage', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.hero = this.querySelector('.sbs-home__hero');
      this.motionQuery = window.matchMedia('(min-width:901px) and (min-height:500px) and (prefers-reduced-motion:no-preference)');
      this.scheduleMotion = () => {
        if (!this.motionFrame && this.motionQuery.matches) this.motionFrame = requestAnimationFrame(() => { this.motionFrame = null; this.updateMotion(); });
      };
      this.updateMotion = () => {
        if (!this.hero) return;
        this.hero.toggleAttribute('data-parallax', this.motionQuery.matches);
        if (!this.motionQuery.matches) { this.hero.style.removeProperty('--sbs-shift'); return; }
        const bounds = this.hero.getBoundingClientRect();
        if (bounds.bottom <= 0 || bounds.top >= window.innerHeight) return;
        const shift = Math.max(-16, Math.min(16, window.scrollY * .06));
        this.hero.style.setProperty('--sbs-shift', shift + 'px');
      };
      window.addEventListener('scroll', this.scheduleMotion, {passive:true,signal:this.controller.signal});
      window.addEventListener('resize', this.scheduleMotion, {passive:true,signal:this.controller.signal});
      this.motionQuery.addEventListener?.('change', this.updateMotion, {signal:this.controller.signal});
      this.updateMotion();
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.links = Array.from(this.querySelectorAll('[data-select]'));
      if (this.panels.length) this.select(this.panels[0].dataset.panel);
      this.addEventListener('click', (event) => {
        const pick = event.target.closest('[data-select]');
        if (pick && this.contains(pick)) {
          event.preventDefault();
          pick.focus({preventScroll:true});
          this.select(pick.dataset.select);
          return;
        }
        const play = event.target.closest('[data-play]');
        if (!play || !this.contains(play) || !/^[A-Za-z0-9_-]+$/.test(play.dataset.play)) return;
        const frame = document.createElement('iframe');
        frame.src = 'https://www.youtube-nocookie.com/embed/' + play.dataset.play + '?autoplay=1&playsinline=1&rel=0';
        frame.title = play.dataset.title;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        const player = play.closest('[data-player]');
        this.restorePlayer();
        this.activePlayer = player;
        this.originalPlayer = Array.from(player.childNodes);
        player.replaceChildren(frame);
        frame.focus();
      }, {signal:this.controller.signal});
    }
    restorePlayer() {
      if (this.activePlayer && this.originalPlayer) this.activePlayer.replaceChildren(...this.originalPlayer);
      this.activePlayer = null;
      this.originalPlayer = null;
    }
    select(id) {
      this.restorePlayer();
      this.panels.forEach(panel => { panel.hidden = panel.dataset.panel !== id; });
      this.links.forEach(link => { if (link.dataset.select === id) link.setAttribute('aria-current','true'); else link.removeAttribute('aria-current'); });
    }
    disconnectedCallback() {
      if (this.motionFrame) cancelAnimationFrame(this.motionFrame);
      this.motionFrame = null;
      this.hero?.removeAttribute('data-parallax');
      this.hero?.style.removeProperty('--sbs-shift');
      this.restorePlayer();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbs-home-quotes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sbs-quote-gallery')) {
  customElements.define('sbs-quote-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.slides = Array.from(this.querySelectorAll('[data-quote]'));
      this.index = 0;
      this.status = this.querySelector('[data-status]');
      this.querySelector('[data-controls]').hidden = this.slides.length < 2;
      this.show(0);
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-direction]');
        if (button && this.contains(button)) this.show(this.index + Number(button.dataset.direction));
      }, {signal:this.controller.signal});
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.quote === event.detail.blockId);
        if (index >= 0) this.show(index);
      }, {signal:this.controller.signal});
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.status.textContent = this.status.dataset.pattern.replace('[current]', this.index + 1).replace('[total]', this.slides.length);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbs-home-tommy"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sbs-tommy-motion')) {
  customElements.define('sbs-tommy-motion', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.picture = this.querySelector('.sbs-tommy__image');
      const section = this.querySelector('.sbs-tommy');
      if (!this.picture || !section) return;
      const motion = window.matchMedia('(prefers-reduced-motion: no-preference)');
      const update = () => {
        this.frame = null;
        if (!motion.matches) {
          this.resetMotion();
          return;
        }
        const bounds = section.getBoundingClientRect();
        if (bounds.bottom < 0 || bounds.top > window.innerHeight) return;
        const progress = Math.max(0, Math.min(1, (window.innerHeight - bounds.top) / (window.innerHeight + bounds.height)));
        const wave = Math.sin(progress * Math.PI * 2);
        this.picture.style.setProperty('--tommy-lift', `${(-10 * wave).toFixed(2)}px`);
        this.picture.style.setProperty('--tommy-tilt', `${(1.8 * wave).toFixed(2)}deg`);
      };
      const schedule = () => {
        if (this.frame == null) this.frame = requestAnimationFrame(update);
      };
      window.addEventListener('scroll', schedule, {passive:true, signal});
      window.addEventListener('resize', schedule, {passive:true, signal});
      motion.addEventListener('change', schedule, {signal});
      update();
    }
    resetMotion() {
      this.picture?.style.removeProperty('--tommy-lift');
      this.picture?.style.removeProperty('--tommy-tilt');
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.frame != null) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.resetMotion();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbs-news-magazine"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sbs-news-magazine')) {
  customElements.define('sbs-news-magazine', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.querySelectorAll('[data-news-topic]').forEach(topic => {
        const cards = [...topic.querySelector('[data-news-grid]').children];
        cards.forEach((card, i) => { card.hidden = i >= 3; });
        const controls = topic.querySelector('[data-topic-controls]');
        if (controls) controls.hidden = false;
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
